import { render } from "./TableList.vue?vue&type=template&id=01a70c48&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"

import "./TableList.vue?vue&type=style&index=0&id=01a70c48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a70c48"]])

export default __exports__